import React from 'react'

function Create() {
    return (
        <div className="text-center">
            Here we create our blog
        </div>
    )
}

export default Create
